export default {
  title: 'Points Mall Config',
  productConfig: 'Product Config',
};
